import { LOAD_INCIDENTS_BY_DEVICE_ID_SUCCESS } from "fleet/redux-store/ui-state/device-incidents/actions";
import {
  FETCH_INCIDENT_BY_ID_SUCCESS,
  UNLOAD_INCIDENTS,
  RESOLVE_INCIDENT_SUCCESS,
} from "fleet/redux-store/ui-state/incidents/actions";
import { defaultArray } from "redux-store/selectors";

// TODO(jhohman): the only difference between this and incidents store
// is the deviceId in the response payload. These should be combined.
const initialState = {
  incidents: defaultArray,
  statusCode: null,
};

function updateDeviceIncidentsReducer(state, action) {
  const { payload } = action;
  const { data: incident } = payload;
  const { id: incidentId } = incident;

  // Can only resolve existing incidents.
  const incidents = state.incidents.map((i) => {
    if (i.id === incidentId) {
      // Resolved incidents are not complete objects merge it with existing.
      return {
        ...i,
        ...incident,
      };
    }

    return i;
  });

  return {
    ...state,
    incidents,
  };
}

function onGetDeviceIncidentsReducer(state, action) {
  const { payload } = action;
  const { data: incident } = payload;
  const { id: incidentId } = incident;

  let exists = false;
  const incidents = state.incidents.map((i) => {
    if (i.id === incidentId) {
      exists = true;
      return incident;
    }

    return i;
  });

  if (!exists) {
    incidents.push(incident);
  }

  return {
    ...state,
    incidents,
  };
}

function deviceIncidentsReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case FETCH_INCIDENT_BY_ID_SUCCESS:
      return onGetDeviceIncidentsReducer(state, action);
    case RESOLVE_INCIDENT_SUCCESS:
      return updateDeviceIncidentsReducer(state, action);
    case LOAD_INCIDENTS_BY_DEVICE_ID_SUCCESS:
      return {
        incidents: payload.data,
      };
    case UNLOAD_INCIDENTS:
      return initialState;
    default:
      return state;
  }
}

export {
  deviceIncidentsReducer,
  updateDeviceIncidentsReducer,
  onGetDeviceIncidentsReducer,
};
